const es = {
    message: {
        login: "Iniciar sesión",
        submit: "Enviar",
        accountInfo: "Información de la cuenta",
        accountNumber: "Número de cuenta",
        serviceLocationAddress: "Dirección de ubicación del servicio",
        billOptions: "Bill Options",
        autopay: "AutoPay",
        upcomingPaymentArrangement: "Upcoming Payment Arrangement",
        usageSummary: "Usage Summary",
        billHistory: "View Bill History",
        currentBill: "View Current Bill",
        payNow: "Pay Now",
        asOf: "As of",
        recentUsage: "Uso reciente",
        usageChartsFooterMessage: "Haga clic en los elementos anteriores para eliminar de la visualización del gráfico",
        servicePoints: "Puntos de servicio",
        type: "Tipo",
        status: "Estado",
        avgDailyUsage: "Avg. Daily Usage",
        view: "Ver",
        dollarsRemaining: "Dólares restantes",
        deferredBalance: "Deferred Balance",
        daysRemaining: "Días restantes",
        billingCycle: "Billing Cycle",
        lastPayment: "Last Payment",
        totalCharges: "Total Charges",
        billDate: "Bill Date",
        billingPeriod: "Billing Period",
        daysInBillingPeriod: "Días en el período de facturación",
        totalAmountBilled: "Total Amount Billed",
        pastDue: "Past Due",
        totalDue: "Total Due",
        registrationNumber: "Número de registro",
        total: "Total",
        convertToPDF: "Convertir a PDF",
        print: "Impresión",
        close: "Cerrar",
        dollars: "Dólares",
        consumption: "Consumo",
        backToMonthly: "Volver a mensual",
        backToDaily: "Volver a diario",
        lastName: "Apellido",
        zipcode: "Código postal",
        next: "Siguiente",
        registerNewAccount: "Registrar una cuenta nueva",
        startManagingYourAccount: "¡Empieza a administrar tu cuenta ahora!",
        currentNotificationSettings: "Configuración de notificación actual:",
        voice: "Voz: ",
        text: "Mensaje de texto: ",
        email: "Email: ",
        emailaddress: "Dirección de Correo Electrónico",
        phonenumberoremailaddress: "Número de Teléfono o Dirección de Correo Electrónico",
        notificationSettingsPage: "Página de configuración de notificaciones",
        approxDollarsRemaining: "Approx Dollars Remaining: ",
        deferredBalance: "Deferred Balance: ",
        approxDaysRemaining: "Approx Days Remaining: ",
        accountBalance: "Account Balance: ",
        avgDailyConsumption: "Avg Daily Consumption: ",
        avgDailyDollarConsumption: "Avg Daily Dollar Consumption: ",
        accountBalanceCustomerMessage: "Below you will find the account balances. You may transfer or adjust funds between the accounts. If you need a refund, or to move funds from one account to another, please call customer support.",
        ok: "De acuerdo",
        cancel: "Cancelar",
        transferDeferredMessage: "Please enter an amount between $0 and ${maxFunds} to apply to your deferred balance. If the amount you requested to transfer exceeds the actual account balance, then we will only transfer what is available.",
        transferAmount: "Transfer Amount: ",
        account: "Cuenta",
        transferAmountTooMuch: "The transfer amount is greater than the max available funds.",
        transfer: "Transfer",
        currentPassword: "Contraseña actual",
        newPassword: "Nueva contraseña",
        confirmNewPassword: "Confirmar nueva contraseña",
        confirmPassword: "Confirmar contraseña",
        currentUsername: "Nombre de usuario actual",
        newUsername: "Nuevo nombre de usuario",
        confirmNewUsername: "Confirmar nuevo nombre de usuario",
        emailAsUsername: "Se requiere una dirección de correo electrónico como nombre de usuario.",
        highTemperature: "Alta temperatura",
        lowTemperature: "Baja temperatura",
        temperature: "Temperatura",
        privacyPolicy: "Política de privacidad",
        copyright: "Derechos de autor",
        serviceLocation: "Ubicación del servicio",
        username: "Nombre de Usuario",
        password: "Contraseña",
        rememberUsername: "Recordar el nombre de usuario",
        supportInfo: "Información de soporte",
        home: "Página de Inicio",
        reports: "Reportes",
        usage: "Consume",
        notification: "Notificación",
        payment: "Pago",
        autopay: "PagoAuto",
        support: "Soporte",
        csrportal: "Portal de CSR",
        welcome: "Bienvenido",
        balance: "Equilibrar",
        profile: "Perfil",
        logout: "Cerrar sesión",
        report: "Informe",
        selectAReport: "Seleccione un informe",
        getCSV: "Obtener CSV",
        printerFriendly: "Impresora amigable",
        runReport: "Sacar un reporte",
        notificationContact: "Contacto de notificación",
        chargesNote: "Cargos por mensajes y datos podrían ser aplicados por su proveedor de servicios de celular",
        active: "Activo",
        addNew: "Añadir nuevo",
        noContactsAvailable: "No hay contactos disponibles",
        verify: "Verificar",
        delete: "Borrar",
        notificationWindow: "Ventana de notificación",
        change: "Cambio",
        lowBalanceNotifications: "Notificaciones de bajo saldo",
        lowBalanceNotificationDaysSelected: "Días de notificación de bajo saldo seleccionados",
        noDataAvailable: "Datos no disponibles",
        billingAddress: "Dirección de Envio",
        changeAddress: "Cambiar dirección",
        addContact: "Agregar contacto",
        save: "Salvar",
        and: " y ",
        anytime: "A cualquier hora del día o de la noche.",
        onlybetween: "Solo entre",
        changeNotificationWindow: "Cambiar ventana de notificación",
        deleteContact: "Borrar contacto",
        deleteContactConfirmation: "¿Estás seguro de que deseas eliminar?",
        verifyCode: "Código de verificación",
        optInToTexting: "Opt-In para enviar mensajes de texto",
        verificationCode: "Código de verificación",
        optInCodeText: "Hemos enviado un mensaje de texto con un OptInCode. Ingrese el código a continuación para confirmar que acepta recibir mensajes de texto de PayGo.",
        optin: "Optado en",
        optinpending: "Optar en Pendiente",
        optoutpending: "Optar fuera Pendiente",
        enteryouraddressin: "Ingrese su dirección en",
        enteracity: "Entrar en una ciudad",
        selectastate: "Selecciona un Estado",
        enterazipcode: "Ingrese un código postal",
        entervalidemailaddress: "¡Error! Por favor, introduce una dirección de correo electrónico válida",
        entervalidphone: "¡Error! Por favor ingrese un número de teléfono válido",
        entervalidphoneoremail: "¡Error! Por favor ingrese un número de teléfono válido o una dirección de correo electrónico válida",
        errorPageFailed: "Se ha producido un error. Por favor, actualice su página.",
        address1: "Dirección 1",
        address2: "Dirección 2",
        city: "Ciudad",
        state: "Estado",
        zip: "Cremallera",
        criticalContact: "Contacto critico",
        limit: "Límite: ",
        add: "Añadir",
        supportInfo: "Información de soporte",
        capsLockOn: "CIERRES CERRADOS EN",
        errorMessage: "Pedimos disculpas, pero ocurrió un error y no se pudo completar su solicitud. Nuestro equipo fue notificado y estamos trabajando para resolver este error.",
        backToHome: "Volver a la página principal",
        sessionWarning: "Advertencia de sesión",
        backToLogin: "Atrás para iniciar sesión",
        passwordMustContain: "La contraseña debe contener al menos",
        addingAccountToExistingLogin: "Si está agregando una cuenta a un inicio de sesión existente, ingrese el nombre de usuario y la contraseña para ese inicio de sesión a continuación.",
        terms: "Acepto los términos y condiciones de este contrato.",
        phoneOrEmail: "Teléfono / Email",
        startDate: "Fecha de Inicio",
        endDate: "Fecha Final",
        daterange: "Rango de Fechas",
        phone: "Teléfono: ",
        //I have a need to get the specific format for date pickers.
        dateformat: "DD/MM/YYYY",
        accountlast4: 'Cuenta 4 últimos',
        action: 'Acción',
        amount: 'Cantidad',
        applystatus: 'Aplicar Estado',
        changeamount: 'Cambiar Cantidad',
        changedate: 'Cambiar Fecha',
        contactinfo: 'Datos Contacto',
        date: 'Fecha',
        delivered: 'Entregado',
        description: 'Descripción',
        details: 'Detalles',
        endingbalance: 'Balance Final',
        generateddate: 'Fecha Generada',
        message: 'Mensaje',
        messagetype: 'Tipo Mensaje',
        meternumber: 'Número Medidor',
        meterreading: 'Lectura Medidor',
        meterstatus: 'Estado Medidor',
        paymenttype: 'Tipo Pago',
        premisename: 'Nombre Premisa',
        readdate: 'Fecha Lectura',
        recieved: 'Recibido',
        senddate: 'Fecha Envio',
        sendstatus: 'Estado Envío',
        serialno: 'Número Serie',
        subject: 'Tema',
        totalconsumption: 'Consumo Total',
        type: 'Tipo',
        unit: 'Unidad',
        voided: 'Anulado',
        //Reports
        accountactivity: 'Actividad De La Cuenta',
        accountbalanceactivity: 'Actividad De Saldo De Cuenta',
        deferredbalanceactivity: 'Actividad De Saldo Diferido',
        meterreadhistory: 'Historial De Lectura Del Medidor',
        meterStatushistory: 'Historial De Estado Del Medidor',
        notificationhistory: 'Historial De Notificaciones',
        processedpayments: 'Pagos Procesados',
        usagestatement: 'Declaración De Uso',
        estUsage: "EST. USO",
        weatherTitle: "{days} DIA PRONÓSTICO / EST. USO",
        noForecastDataAvailable: "No hay datos de pronóstico disponibles",
        getNestThermostat: "Actualmente no tiene un termostato Nest registrado. Haga clic a continuación para otorgar permiso a Georgia Power para recuperar sus datos por usted.",
        loginToNest: "Iniciar sesión en Nest",
        thermostats: "Termostatos",
        thermostat: "Termostato",
        cooling: "Enfriamiento",
        heating: "Calefacción",
        off: "Apagado",
        target: "Objetivo",
        enterDailyGoal: "Introduce tu objetivo diario",
        setDailyGoal: "Establecer la meta diaria",
        removeDailyGoal: "Eliminar objetivo diario",
        lastMonth: "El Mes Pasado",
        last3Months: "Últimos 3 meses",
        last6Months: "Últimos 6 meses",
        last9Months: "Últimos 9 meses",
        customRange: "Rango Personalizado",
        selectPaymentOption: "Por favor seleccione una opción de pago",
        noPaymentTypesAvailable: "No hay procesadores de pago disponibles.",
        notificationType: "Tipo de notificación",
        accountNotValid: "Cuenta no válida",
        defaultSavedPayment: "Método de pago guardado por defecto",
        managePaymentMethods: "Administrar los métodos de pago",
        noPaymentMethodAvailableMessage: "No tiene un método de pago predeterminado disponible. Por favor agregue uno debajo.",
        autoPayMessage: "Sus cuentas pueden configurarse para recargar su saldo cuando faltan dos días aproximadamente. La cantidad elegida se deducirá de su tarjeta de crédito o débito predeterminada en ese momento.",
        routingNumber: "Enrutamiento #",
        expired: "Muerto",
        autoPayWarning: "No tiene un método de pago predeterminado disponible.Cualquier pago de pago automático seleccionado no se procesará sin un método de pago predeterminado.Por favor agregue uno debajo.",
        noActivePremisesAvailable: "No hay locales activos disponibles.",
        coverDeferredBalance: "Saldo diferido de la cubierta",
        unenroll: "Darse de baja",
        autopaySavedMessage: "La cantidad de Autopay se ha guardado.¿Te gustaría iniciar un pago automático de ${autopayAmt}?",
        applyPaymentNow: "¿Aplicar el pago ahora ?",
        noRecordsToDisplay: "No hay registros que mostrar.",
        premise: "Premisa",
        selectLocation: "Selecciona una ubicación",
        statementDate: "Fecha de declaración",
        address: "Dirección",
        currentCharges: "Cargos actuales",
        usageCharge: "Carga de uso",
        miscAdjustments: "Misceláneo Ajustes",
        totalCurrentCharges: "Cargos actuales totales",
        meterNum: "Medidor #",
        servicePeriod: "Periodo de servicio",
        daysOfService: "Días de servicio",
        startReading: "Empieza a leer",
        endReading: "Lectura final",
        uomUsed: "{uom} usado",
        consumptionCharges: "Cargos de consumo",
        rateName: "Nombre de la tarifa",
        rateDescription: "Descripción de la tasa",
        amountCharged: "Cantidad cargada",
        subtotal: "Total parcial",
        viewStatement: "Ver declaración",
        statementDates: "Fechas de Declaración",
        serviceType: "Tipo de servicio",
        charges: "Los cargos",
        adjustments: "Ajustes",
        adjustment: "Ajustamiento",
        unitsUsed: "Unidades utilizadas",
        reconnectHeading: "Reconecte el medidor",
        reconnectMessage: "Esto le permitirá restaurar la energía de su medidor. Asegúrese de que todos los aparatos eléctricos estén apagados y no supongan un peligro cuando se restablezca la alimentación. Usted asume toda la responsabilidad de restablecer la alimentación del medidor.",
        connect: "Conectar",
        notAuthorizedMessage: "No tiene permisos para acceder a esta página.",
        sessionTimeoutMessage: "Tiempo de espera de sesión: su sesión ha finalizado por su seguridad.Por favor comience de nuevo.",
        welcomeMessage: "Bienvenido a {repName}!!",
        welcomePageNotificationMessage: "Para agregar o editar métodos de contacto vaya a ",
        unsubscribe: "Darse de baja",
        unsubscribeSuccessText: "¡Gracias! Su correo electrónico {email} se ha cancelado correctamente. ",
        unsubscribeFailText: "No pudimos cancelar la suscripción de su correo electrónico {email} debido a que las reglas del programa requieren que se habilite al menos una opción de correo electrónico o mensaje de texto. ",
        unsubscribeLoginText: "Haga clic aquí para actualizar sus notificaciones.",
        sendBarcode: "Enviar código de barras",
        dailyUsageAlert: "Alerta de uso diario"
    }
}

export default es